import { render, staticRenderFns } from "./form-comment.vue?vue&type=template&id=415f329e&"
import script from "./form-comment.vue?vue&type=script&lang=js&"
export * from "./form-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports